import { useContext } from "react";
import { format } from "date-fns";

import { AuthContext } from "src/contexts/auth.context";

import "./message-box.style.scss";

// const MessageBox = ({ isMyMessage, message }) => {
const MessageBox = ({ messageInstance }) => {
	const { user } = useContext(AuthContext);
	const { userId } = user;

	const {
		message,
		// receiverId,
		senderId,
		date,
	} = messageInstance;

	const isMyMessage = userId === senderId;

	return (
		<div className={`size400 message-box ${isMyMessage ? "my-message" : "others-message"}`}>
			<div className="text">
				{message}
				<span className="time">{format(date, "HH:mm")}</span>
			</div>
		</div>
	);
};

export default MessageBox;
